
export const SET_Quiz_FIRST = 'SET_Quiz_FIRST';

export const SET_Quiz_SECOND = 'SET_Quiz_SECOND';

export const SET_Quiz_THIRD = 'SET_Quiz_THIRD';

export const SET_TEST_ID = 'SET_TEST_ID';

